import React from 'react';

import InputCost from '../../widgets/input-cost';
import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import InputPlaceholder from '../../widgets/input-placeholder';
import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class OpenPayElement extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			minCost: this.props.data.min ? this.props.data.min : "0.00",
			maxCost: this.props.data.max ? this.props.data.max : ""
		}
	}

	onMinChange = (newMin) => {

		if (isNaN(newMin)) {
			return;
		}

		if (newMin > 0) {
			this.props.requiredToggle(true);
		} else {
			this.props.requiredToggle(false);
		}

		this.setState({
			minCost: newMin
		}, () => {
			if(
				Number(newMin) > Number(this.state.maxCost)
				&&
				newMin
				&&
				this.state.maxCost
			) {
				this.setState({
					minCost: this.state.maxCost
				}, () => {
					alert("Min value must be less than max value.");
				});
			}
		});
	}

	onMaxChange = (newMax) => {

		if (isNaN(newMax)) {
			return;
		}

		this.setState({
			maxCost: newMax
		}, () => {
			if(
				Number(newMax) < Number(this.state.minCost)
				&&
				newMax
				&&
				this.state.minCost
			) {
				this.setState({
					maxCost: this.state.minCost
				}, () => {
					alert("Max value must be greater than min value.");
				});
			}
		});
	}

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel,
			data: {
				uniqueId,
				hint,
				attributes,
				required,
				min,
				max,
				label,
				title,
				placeholder
			}
		} = this.props;

		const {
			minCost,
			maxCost
		} = this.state

		const localization = new Localization(window.edlio.localizations);
		const publicId = `${uniqueId}_public_checkbox`;
		const useCheckbox = minCost === maxCost;

		return (
			<div className={`${ useCheckbox  ? 'sale-item-element open' : 'open-pay-element'} text input`}>
				{
					!useCheckbox
					&&
					<header>
						<InputLabel ref='label' label={localization.localize(label)} required={required} placeholder={placeholder} usePlaceholderLabel={usePlaceholderLabel} />
						<InputHint ref='hint' label={localization.localize("Add Description")} hint={hint} placeholder={"Description"} />
					</header>
				}
				{
					useCheckbox 
					&&
					<React.Fragment>
						<div className='required-additions'>
							<div className={"force-require-checkbox"} >
								<input ref='publicRequiredBox' id={publicId} type='checkbox' checked={required} disabled/>
								<label htmlFor={publicId}/>
							</div>
						</div>
						<div className='item-info'>
						<header>
							<InputLabel ref='label' label={localization.localize(label)} required={required} placeholder={placeholder} usePlaceholderLabel={usePlaceholderLabel} />
							<InputHint ref='hint' label={localization.localize("Add Description")} hint={hint} placeholder={"Description"} />
						</header>
					</div>
					</React.Fragment>
				}
			
				<div className='open-pay-input-container'>
					{
						useCheckbox 
						&&
						<div className='item-info-preview'>
							<div className='item-label-preview'>
								{label}
								{required && <em className='required-indicator'>*</em>}
							</div>
							<div className='price-preview'>
								<span>{localization.localize('Price') + ':$' + minCost }</span>
							</div>
						</div>
					}
					<React.Fragment>
						<div className="placeholder">
							<span className={"currency-symbol"}>$</span>
							<span>{useCheckbox ? minCost : localization.localize('Amount')}</span>
						</div>
						<span className="helper-txt">{localization.localize('from min')}</span>
						<InputCost
							ref='minCost'
							includeLabel={false}
							cost={this.state.minCost}
							onMinChange={this.onMinChange}
						/>
						<span className="helper-txt">{localization.localize('to max')}</span>
						<InputCost
							ref='maxCost'
							includeLabel={false}
							cost={this.state.maxCost}
							onMaxChange={this.onMaxChange}
						/>
					</React.Fragment>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/open-pay.js